import React, { useState, useRef } from 'react';

function AudioProcessor() {
  const [audioFile, setAudioFile] = useState(null);
  const [waitTime, setWaitTime] = useState(0); // 待機時間を状態として管理
  const audioContextRef = useRef(null);
  const sourceRef = useRef(null);
  const processorRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setAudioFile(URL.createObjectURL(file));
  };

  const handlePlay = async () => {
    if (!audioFile) return;

    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }

    const audioContext = audioContextRef.current;

    const response = await fetch(audioFile);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

    if (sourceRef.current) {
      sourceRef.current.disconnect();
      processorRef.current.disconnect();
    }

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;

    const processor = audioContext.createScriptProcessor(2048, 1, 1);
    processor.onaudioprocess = (audioProcessingEvent) => {
      const inputBuffer = audioProcessingEvent.inputBuffer;
      const outputBuffer = audioProcessingEvent.outputBuffer;

      for (let channel = 0; channel < outputBuffer.numberOfChannels; channel++) {
        const inputData = inputBuffer.getChannelData(channel);
        const outputData = outputBuffer.getChannelData(channel);

        // 擬似的に負荷をかけるための待機処理
        const start = Date.now();
        while (Date.now() - start < waitTime);

        for (let sample = 0; sample < inputBuffer.length; sample++) {
          outputData[sample] = inputData[sample];
        }
      }
    };

    source.connect(processor);
    processor.connect(audioContext.destination);
    source.start(0);

    sourceRef.current = source;
    processorRef.current = processor;
  };

  return (
    <div>
      <input type="file" accept="audio/*" onChange={handleFileUpload} />
      <input
        type="number"
        value={waitTime}
        onChange={(e) => setWaitTime(Number(e.target.value))}
        placeholder="Wait time (ms)"
      />
      <button onClick={handlePlay}>再生</button>
    </div>
  );
}

export default AudioProcessor;
